import { render } from "./ProductListRecommendPage.vue?vue&type=template&id=6e5b7826&scoped=true"
import script from "./ProductListRecommendPage.vue?vue&type=script&lang=js"
export * from "./ProductListRecommendPage.vue?vue&type=script&lang=js"

import "./ProductListRecommendPage.vue?vue&type=style&index=0&id=6e5b7826&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e5b7826"

export default script